import pathfinder from '@fiverr-private/pathfinder';

const STEP_SLUG = 'choose-niche';
const PLATFORM = 'shopify';

export const storeBuilderIconUrl =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9568512627a2561e288b5d6613230534-1749564654941/storeIcon.png';

export const storeBuilderUrl = pathfinder('ai_store_builder_wizard', {
    platform: PLATFORM,
    step_slug: STEP_SLUG,
});
